<nb-card class="attach-equipment-dialog">
  <nb-card-header class="header">
    <div class="title">{{ "asset_form_drawer.compliance.control_report.attach_equipment" | translate }}</div>
    <div class="header-actions">
      <span class="close-btn" (click)="cancel()">
        <i class="fa-light fa-x"></i>
      </span>
    </div>
  </nb-card-header>
  <nb-card-body class="body">
    @if (loading) {
      <div class="loading-container">
        <nb-spinner size="medium"></nb-spinner>
      </div>
    } @else {
      <div class="search-container">
        <div class="search-input-wrapper">
          <i class="fa-light fa-magnifying-glass search-icon"></i>
          <input
            type="text"
            [placeholder]="'Search' | translate"
            [value]="searchQuery"
            (input)="onSearchChange($event)"
            class="search-input"
          />
          @if (searchQuery.trim()) {
            <button type="button" class="clear-btn" (click)="clearSearch()" tabindex="-1">
              <i class="fa-solid fa-times"></i>
            </button>
          }
        </div>
      </div>

      <div class="equipment-list-container">
        @if (filteredEquipmentList.length === 0) {
          <div class="form-field empty-state">
            <div class="field-value">
              {{ "No assets found" | translate }}
            </div>
          </div>
        } @else {
          <div class="equipment-list">
            @for (equipment of filteredEquipmentList; track equipment.id) {
              <div class="equipment-item" (click)="toggleEquipmentSelection(equipment.id)">
                @if(multipleChoice) {
                  <nb-checkbox
                    [checked]="isEquipmentSelected(equipment.id)"
                    (checkedChange)="toggleEquipmentSelection(equipment.id)"
                    (click)="$event.stopPropagation()"
                  ></nb-checkbox>
                }
                <div class="equipment-content" (click)="selectEquipment(equipment)">
                  <div class="equipment-thumbnail">
                    @if (getEquipmentThumbnail(equipment)) {
                      <img [src]="getEquipmentThumbnail(equipment)" [alt]="equipment.label" />
                    } @else {
                      <div class="placeholder-thumbnail">
                        <i class="fa-light fa-image"></i>
                      </div>
                    }
                  </div>
                  <div class="equipment-details">
                    <div class="equipment-label">{{ equipment.label || '-' }}</div>

                    <div class="equipment-info perimeter-info">
                      <span class="info-item">
                        <span class="quantity-color">{{ getQuantity(equipment) }}</span>
                        <span class="info-separator">-</span>
                        <span class="perimeter-value perimeter-label-alt">{{ getPerimeterHierarchy(equipment) }}</span>
                      </span>
                    </div>

                    <div class="equipment-info state-info">
                      <span class="info-item">
                        <span
                          class="state-label"
                          [class.critical-label]="isLastEvaluationCritical(equipment)"
                          [class.non-critical-state]="!isLastEvaluationCritical(equipment)"
                        >
                          {{ getLastEvaluationStatus(equipment) }}
                          <ng-container *ngIf="getLastEvaluationDate(equipment) as lastDate">
                            - {{ lastDate }}
                          </ng-container>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </nb-card-body>
</nb-card>

